import { assetUrl } from '../config/asset-config';

(function () {
    'use strict';

    angular.module('thankview.recorder', ['thankview.global'])
        .directive('tvRecorder', ['recorderService', 'webcamService', '$rootScope', '$timeout', 'transition', '$window', '$document', 'ajax', function (recorderService, webcamService, $rootScope, $timeout, transition, $window, $document, ajax) {
            return {
                restrict: 'E',
                templateUrl: '/templates/recorder/recorder.html?v=' + config.version,
                scope: {
                    options: '=?',
                },
                link: function (scope, element) {
                    var recorderContainer;
                    var countdownElement;
                    var resizeTimer;

                    scope.portalHasVirtualBackgrounds = $rootScope.currentPackage ? $rootScope.currentPackage.details.virtual_background_credited : false;
                    scope.isMobile = config.isMobile;

                    if (!scope.options) {
                        scope.options = {
                            showTipsButton: false,
                            showInstructionsButton: false,
                            showStartOverButton: false,
                        };
                    }

                    scope.options.showScriptButton = true;

                    scope.overlayInstructions = false;
                    scope.scriptText = '';

                    scope.toggleScriptOverlay = function (forceClose = false) {
                        if (forceClose) {
                            scope.showScript = false;
                        } else {
                            scope.showScript = !scope.showScript;
                            if (scope.showScript) {
                                scope.showInstructions = false;
                            }
                        }
                    };


                    scope.doneEditingScript = function () {
                        var formattedScriptText = scope.scriptText.replace(/(?:\r\n|\r|\n)/g, '<br />');
                        $rootScope.$broadcast('recorder-script-updated', formattedScriptText);
                    };

                    scope.handleScriptChange = function (value) {
                        scope.scriptText = value;
                    };

                    console.log('linking tvRecorder with these options:');
                    console.log(scope.options);

                    scope.$on('recorder-load-video', function () {
                        scope.video = recorderService.review.getVideo();
                    });

                    scope.$on('play-recording-tips', function () {
                        scope.openExample();
                    });

                    scope.init = function () {
                        if (!$window.config.loaded) {
                            $timeout(scope.init, 100);
                            return;
                        }

                        recorderContainer = angular.element(element[0].querySelector('.tv-recorder'));
                        countdownElement = angular.element(element[0].querySelector('.countdown'));

                        scope.resolutions = recorderService.webcam.getResolutions();
                        scope.internalResolutions = recorderService.webcam.getInternalResolutions();

                        scope.backgrounds = [
                            { label: 'Blur My Background', type: 'blur', selected: false },
                            { label: 'Choose Virtual Background', type: 'virtual', selected: false },
                        ];

                        scope.canShowInternalResolutions = false;

                        scope.$on('recorder-devices-detected', function ($event, videoOptions, audioOptions) {
                            scope.videoOptions = videoOptions;
                            scope.audioOptions = audioOptions;

                            console.log(videoOptions, audioOptions);
                        });
                        scope.$on('recorder-countdown', function ($event, time) {
                            scope.recordingTime = 0;
                            scope.countdown(time);
                        });
                        scope.$on('recorder-end-countdown', function () {
                            scope.endCountdown();
                        });
                        scope.$on('recording', function ($event, time, limit) {
                            const timeSeconds = time % 60;
                            const limitSeconds = limit % 60;
                            scope.recordingTime = Math.floor(time / 60) + ':' + (timeSeconds < 10 ? '0' : '') + (timeSeconds % 60);
                            scope.recordingLimit = Math.floor(limit / 60) + ':' + (limitSeconds < 10 ? '0' : '') + (limitSeconds % 60);

                            if (time >= limit) {
                                scope.stopRecording();
                            }

                            scope.$apply();
                        });
                        scope.$on('recorder-uploading', function ($event, uploadPercentage, id) {
                            const currentId = recorderService.getCurrentId();
                            scope.uploadPercentage = (id === currentId) ? uploadPercentage : '';
                        });
                        scope.$on('recorder-open-uploader', scope.openFileUploader);

                        angular.element($window).on('resize', function () {
                            $timeout.cancel(resizeTimer);
                            resizeTimer = $timeout(scope.resize, 200);
                        });

                        recorderService.init('recorder-webcam', 'recorder-review');

                        recorderService.initWebcamService();

                        recorderService.onStateChange(scope.stateChanged);

                        scope.resize();
                        scope.createFileUploader();
                        scope.initTranslations();
                    };

                    scope.initTranslations = function () {
                        var locale = $window.config.locale;
                        var params = {
                            filename: 'recorder',
                        };

                        ajax.post('/api/translate/' + locale, params).then(function (data) {
                            scope.trans = data.trans;
                        });
                    };

                    scope.resize = function () {
                        var maxHeight = $window.innerHeight * 0.8;
                        var parentWidth = element[0].parentElement.offsetWidth;
                        var height = Math.min(parentWidth * 3 / 4, maxHeight);
                        var width = height * 4 / 3;
                        var fontSizes = [
                            { width: 500, size: 'large' },
                            { width: 400, size: 'medium' },
                            { width: 300, size: 'small' },
                            { width: 0, size: 'xsmall' },
                        ];

                        // check that the parent width can be measurable
                        if (parentWidth > 0) {
                            // set height of recorder container
                            recorderContainer.css('width', width + 'px');
                            recorderContainer.css('height', height + 'px');

                            // set recorder font size based on width of the container
                            scope.fontSize = null;
                            angular.forEach(fontSizes, function (fontSize) {
                                if (width > fontSize.width && !scope.fontSize) scope.fontSize = fontSize.size;
                            });
                        } else {
                            $timeout.cancel(resizeTimer);
                            resizeTimer = $timeout(scope.resize, 200);
                        }
                    };

                    scope.stateChanged = function (state) {
                        scope.state = state;

                        if (scope.state === 'beginRecording') {
                            scope.startCountdown();
                        }

                        if (scope.state === 'stopped' || scope.state === 'review') {
                            scope.showScript = false;
                        }

                        if (scope.state === 'beginReview') {
                            scope.showScript = false;
                        }
                    };

                    scope.setResolution = (resolution) => {
                        recorderService.webcam.setResolution(resolution);
                    };

                    scope.setInternalResolution = (resolution) => {
                        recorderService.webcam.setInternalResolution(resolution);
                    };

                    scope.setCamera = (device) => {
                        recorderService.webcam.setCamera(device);
                    };

                    scope.setAudio = (device) => {
                        recorderService.webcam.setAudio(device);
                    };

                    scope.startRecording = function () {
                        recorderService.webcam.startRecording();
                    };

                    scope.stopRecording = function () {
                        if (scope.options.showInstructionsButton) {
                            scope.toggleInstructionOverlay(true); // Force-close the instruction overlay if visible.
                        }

                        scope.scriptText = '';
                        scope.showScript = false;
                        recorderService.webcam.stopRecording(recorderService.getCurrentId());
                    };

                    scope.startCountdown = function () {
                        countdownElement.removeClass('fade-long fadeOut');

                        $timeout(function () {
                            countdownElement.addClass('fadeIn');
                            countdownElement.find('span').addClass('fa fa-spinner fa-spin').attr('style', '').html('');
                        }, 20);
                    };

                    scope.countdown = function (time) {
                        if (scope.state !== 'recordingCountdown') {
                            return;
                        }

                        var count = countdownElement.find('span').removeClass('fa fa-spinner fa-spin');
                        var num = Math.ceil((3000 - time) / 1000);
                        var remainder = time % 1000;
                        var opacity;

                        if (remainder < 500) {
                            opacity = remainder / 500;
                        } else {
                            opacity = remainder < 800 ? 1 : ((1000 - remainder) / 200);
                        }

                        count.html(num);
                        count.css({
                            transform: 'scale(' + (1 + (1000 - remainder) * 0.3 / 1000) + ')',
                            opacity: opacity,
                        });
                    };

                    scope.endCountdown = function () {
                        if (scope.state !== 'recordingCountdown' || countdownElement.hasClass('fadeOut')) return;

                        countdownElement.addClass('fade-long fadeOut');

                        transition.end(countdownElement, function () {
                            recorderService.setState('recording');
                            scope.$apply();
                        });
                    };

                    scope.createFileUploader = function () {
                        var inputHtml = '<input type="file" name="file" accept="video/mpg,video/mpeg,video/mp4,video/x-m4v,video/avi,video/x-matroska,video/quicktime,video/*;capture=camcorder" aria-label="Upload a Video">';

                        angular.element(element[0].querySelector('.tv-recorder input[type=file]')).remove();
                        angular.element(element[0].querySelector('.tv-recorder')).append(inputHtml);
                        angular.element(element[0].querySelector('.tv-recorder input[type=file]')).on('change', scope.uploadFile);
                    };

                    /**
                     * Function to start the "recording tips" video
                     */
                    scope.openExample = function () {
                        // check if we have a specific locale and set captions appropriately
                        // TODO: localize video player caption labels - currently English only as "Captions On"
                        let captions;
                        switch (config.locale) {
                            case 'es-MX':
                                captions = assetUrl('uploads-oneoff/2020/record_tips_sp-mx.vtt');
                                break;
                            case 'fr-CA':
                                captions = assetUrl('uploads-oneoff/2020/record_tips_fr-ca.vtt');
                                break;
                            case 'ja-JP':
                                captions = assetUrl('uploads-oneoff/2021/record_tips_ja-jp.vtt');
                                break;
                            case 'de-DE':
                                captions = assetUrl('uploads-oneoff/2021/record_tips_de-de.vtt');
                                break;
                            case 'zh-HK':
                                captions = assetUrl('uploads-oneoff/2021/record_tips_zh-hk.vtt');
                                break;
                            case 'zh-TW':
                                captions = assetUrl('uploads-oneoff/2021/record_tips_zh-tw.vtt');
                                break;
                            case 'zh-CN':
                                captions = assetUrl('uploads-oneoff/2021/record_tips_zh-cn.vtt');
                                break;
                            case 'ko-KR':
                                captions = assetUrl('uploads-oneoff/2021/record_tips_ko-kr.vtt');
                                break;
                            case 'pt-BR':
                                captions = assetUrl('uploads-oneoff/2021/record_tips_pt-br.vtt');
                                break;
                            default:
                                captions = 'https://d310lx2axip3m3.cloudfront.net/captions/5acd235dabfeb.vtt';
                        }

                        var video = {
                            video_path: assetUrl('assets/videos/business/video_request_tips.mp4'),
                            image: assetUrl('assets/videos/business/video_request_tips_thumb.jpg'),
                            caption_url: captions,
                            auto_start: true,
                            onComplete: function () {
                                recorderService.stopVideos();
                                recorderService.rerecord();
                            },
                        };

                        recorderService.review.load(video);
                    };

                    scope.openFileUploader = function () {
                        element[0].querySelector('.tv-recorder input[type=file]').click();
                    };

                    scope.uploadFile = function (e) {
                        var file = e.target.files[0];

                        if (!file) return;

                        if (file.type) {
                            var fileMimeType = file.type.split('/')[0];

                            if (fileMimeType !== 'video' && fileMimeType !== 'audio') {
                                if ($window.Bugsnag) {
                                    Bugsnag.notify(new Error('Video Format Error. Error with type: ' + file.type));
                                }
                                $rootScope.$broadcast('open-message', 'Incorrect video format. Please upload mp4, mpg, mpeg, mov, avi, webm, or m4v file extension.');
                                return;
                            }
                        }

                        if (file.size > config.maxFileSize) {
                            $rootScope.$broadcast('open-message', 'File size is too large. 600MB max size.');
                            return;
                        }

                        // upload file to media server
                        recorderService.fileUploader.upload(e);

                        // recreate file uploader
                        scope.createFileUploader();
                    };

                    scope.stopReview = function () {
                        recorderService.review.reload();
                    };

                    scope.openErrorMessage = function () {
                        $rootScope.$broadcast('open-message', 'This video can\'t be previewed at the moment.');
                    };

                    scope.toggleInstructionOverlay = function (forceClose = false) {
                        $rootScope.$broadcast('toggleInstructionOverlay', forceClose);
                    };

                    // start over button created for personal videos
                    scope.startOverRecording = function () {
                        recorderService.webcam.startOver();
                    };

                    scope.handleBlur = function (val) {
                        webcamService.setBlur(val);
                    };

                    const imageInput = $document[0].getElementById('imageInput');
                    // Modify the setBackgroundSelection function to handle different background types
                    scope.setBackgroundSelection = function (background) {
                        if (background.type === 'virtual') {
                            // For the 'virtual' background, trigger the click event on the file input element
                            imageInput.click();
                        } else if (background.type === 'blur') {
                            scope.handleBlur(11);
                        } else {
                            scope.handleBlur(0);
                        }

                        // Set 'selected' property based on the selected background
                        scope.backgrounds.forEach((bg) => bg.selected = bg.type === background.type);
                        const clearBackground = { label: 'Clear Background', type: 'clear', selected: false };

                        if (scope.backgrounds.filter((data) => data.type === 'clear').length === 0) {
                            scope.backgrounds.push(clearBackground);
                        }
                        if (scope.backgrounds.filter((data) => data.type === 'clear' && data.selected).length === 1) {
                            scope.backgrounds.pop();
                        }
                        scope.canShowInternalResolutions = scope.backgrounds.filter((bg) => bg.selected);
                    };

                    // Listen for changes in the file input element (when an image is selected)
                    imageInput.addEventListener('change', function (event) {
                        var file = event.target.files[0];
                        if (file) {
                            var reader = new FileReader();
                            reader.onload = function (e) {
                                scope.$apply(function () {
                                    webcamService.setImage(e.target.result);
                                });
                            };

                            reader.readAsDataURL(file);
                        }
                    });


                    scope.init();
                },
            };
        }]);
}());
